import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactMapboxGl, { ScaleControl } from 'react-mapbox-gl'
import { MAPBOX_ACCESS_TOKEN } from '../config/constants'
// import exportCanvas from '../utility/exportCanvas'
import Default from '../layers/Default'
import SmartIce from '../layers/SmartIce'
import SmartIceQamutik from '../layers/SmartIceQamutik'
import SmartIceQamutikLineString from '../layers/SmartIceQamutikLineString'
import SmartIceQamutikVector from '../layers/SmartIceQamutikVector'
import Buoys from '../layers/Buoys'
import RiverIce from '../layers/RiverIce'
import MopraVector from '../layers/MopraVector'
import WellsiteRank from '../layers/WellsiteRank'
import IceDrift from '../layers/IceDrift'
import IceDriftVelocity from '../layers/IceDriftVelocity'
import IceDeformation from '../layers/IceDeformation'
import LandDeformationInsar from '../layers/LandDeformationInsar'
import MopraWellsites from '../layers/MopraWellsites'
import WellsiteNdviControl from '../layers/WellsiteNdviControl'
import WellsiteNdviLease from '../layers/WellsiteNdviLease'
import WellsiteEviControl from '../layers/WellsiteEviControl'
import WellsiteEviLease from '../layers/WellsiteEviLease'
import LandCover2010 from '../layers/LandCover2010'
import AnnualCropInventory from '../layers/AnualCropInventory'
import WaterTemperature from '../layers/WaterTemperature'
import WaterSediment from '../layers/WaterSediment'
import WaterRiverSsc from '../layers/WaterRiverSsc'
import WaterLakeTss from '../layers/WaterLakeTss'
import WaterLakeChl from '../layers/WaterLakeChl'
import WaterLakeTssVector from '../layers/WaterLakeTssVector'
import WaterLakeTssHeatmap from '../layers/WaterLakeTssHeatmap'
import Mopra from '../layers/Mopra'
import Sentinel1 from '../layers/Sentinel1'
import Sentinel1SmartIce from '../layers/Sentinel1SmartIce'
import Sentinel2 from '../layers/Sentinel2'
import Sentinel2Transparent from '../layers/Sentinel2Transparent'
import Sentinel2SixMonth from '../layers/Sentinel2SixMonth'
import Sentinel1SixMonth from '../layers/Sentinel1SixMonth'
import Sentinel2Ndvi from '../layers/Sentinel2Ndvi'
import Sentinel2LeakDetection from '../layers/Sentinel2LeakDetection'
import Sentinel2Raster from '../layers/Sentinel2Raster'
import Modis from '../layers/Modis'
import CmemsSeaIce from '../layers/CmemsSeaIce'
import CmemsSnowThickness from '../layers/CmemsSnowThickness'
import CmemsSurfaceTemperature from '../layers/CmemsSurfaceTemperature'
import Coastline from '../layers/Coastline'
import InfrastructurePipeline from '../layers/InfrastructurePipeline'
import InfrastructurePipelineVector from '../layers/InfrastructurePipelineVector'
import InfrastructurePipelineBuffer from '../layers/InfrastructurePipelineBuffer'
import LeakDetection from '../layers/LeakDetection'
import PipelineGreen from '../layers/PipelineGreen'
import Infrastructure from '../layers/Infrastructure'
import BriggsIceDepth from '../layers/BriggsIceDepth'
import BriggsIceType from '../layers/BriggsIceType'
import PolarviewApp from '../layers/PolarviewApp'
import FloodHazard from '../layers/FloodHazard'
import FloodRiverClassification from '../layers/FloodRiverClassification'
import RiverFloodMonitoring from '../layers/RiverFloodMonitoring'
import BadgerMask from '../layers/BadgerMask'
import RiverIceMarkers from '../layers/RiverIceMarkers'
import ExploitsMarkers from '../layers/ExploitsMarkers'
import MapActions from '../redux/mapRedux'
import ChartActions from '../redux/chartRedux'
import DataActions from '../redux/dataRedux'
import TimestampActions from '../redux/timestampRedux'
import ObjectActions from '../redux/objectRedux'
import ClickActions from '../redux/clickRedux'
import MouseActions from '../redux/mouseRedux'
import convertBoundsToMercatorBoundingBox from '../utility/convertBoundsToMercatorBoundingBox'
import { withErrorBoundary } from '../errors/ErrorBoundary'
import IceDriftDeformationShear from '../layers/IceDriftDeformationShear'
import * as layers from '../layers/'

const WEATHER_KEY = 'e4053ad41a8f6912b38a324255db85af'

const weatherUrl = (lng, lat, weatherKey = WEATHER_KEY) =>
  `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lng}&appid=${weatherKey}`

const fetchWeather = async url => {
  const response = await fetch(url)
  const json = await response.json()
  // console.log(json)
  return json
}

const Map = ReactMapboxGl({
  accessToken: MAPBOX_ACCESS_TOKEN,
  attributionControl: false
})

// const setFilter = (map, layer, filter) => {
//   if (map.getLayer(layer)) {
//     map.setFilter(layer, filter)
//   }
// }

class MapboxMap extends Component {
  // componentWillReceiveProps = props => {
  //   if (props.maxBounds !== this.maxBounds) {

  //   }
  // }

  onStyleLoad = map => {
    const { actions } = this.props
    actions.boundsChanged(map.getBounds())
    actions.toggleCenterChanged(map.getCenter())
    actions.toggleZoomChanged(map.getZoom())
  }
  updateBounds = (map, event) => {
    const { actions } = this.props

    actions.boundsChanged(map.getBounds())
    actions.toggleCenterChanged(map.getCenter())
    actions.toggleZoomChanged(map.getZoom())
  }

  handleClick = (map, event) => {
    const { actions } = this.props
    const { lng, lat } = event.lngLat
    const features = map.queryRenderedFeatures(event.point)
    // console.log(features)
    // convertBoundsToMercatorBoundingBox(map.getBounds())
    // console.log(map.getBounds())
    // console.log(map.getZoom())
    // console.log(features)
    // console.log(map.getStyle())
    // const maxBounds = map.getMaxBounds()
    // console.log(maxBounds)
    // window.maxBounds = maxBounds
    window.map = map
    const uuids = [
      ...new Set(
        features.map(
          feature => feature.properties.uuid || feature.properties.ogc_fid
        )
      )
    ]
    uuids.map(uuid => actions.objectToggled({ uuid }))
    actions.featuresSelected(features)
    fetchWeather(weatherUrl(lng, lat))

    // actions.chartDataUpdated(features)
    actions.pointDataRequested(lng, lat)
    actions.clickEventUpdated(event)
  }

  handleDataLoading = (map, event) => {
    // console.log(map)
    // console.log(event)
  }

  handleMouseMove = (map, event) => {
    const { actions, uuidsHighlighted } = this.props
    const features = map.queryRenderedFeatures(event.point)
    const uuids = [...new Set(features.filter(feature => feature.properties.uuid).map(feature => feature.properties.uuid))]
    if (uuids.length !== uuidsHighlighted.length) {
      actions.uuidsHighlighted(uuids)
    }

    actions.mouseChanged(event)
  }

  render () {
    const {
      authenticated,
      center,
      idToken,
      maxBounds,
      pitch,
      style,
      zoom
    } = this.props
    // console.log(Object.values(layers))
    return (
      <Map
        showTileBoundaries={true}
        onStyleLoad={this.onStyleLoad}
        center={center}
        zoom={zoom}
        maxBounds={maxBounds}
        pitch={pitch}
        style={style}
        movingMethod={'jumpTo'}
        onMoveEnd={this.updateBounds}
        onMouseMove={this.handleMouseMove}
        onClick={this.handleClick}
        containerStyle={{
          height: '100%',
          width: '100%',
          margin: '0 0 auto'
        }}
      >
        <ScaleControl style={{ bottom: '5px' }} />
        {authenticated &&
          idToken && (
            <div>
              <Default />
              <LandCover2010 />
              <AnnualCropInventory />
              <LandDeformationInsar />
              <WaterTemperature />
              <WaterSediment />
              <WaterRiverSsc />
              <WaterLakeTss />
              <WaterLakeTssVector />
              <WaterLakeTssHeatmap />
              <WaterLakeChl />
              <SmartIce />
              <SmartIceQamutik />
              <SmartIceQamutikLineString />
              <SmartIceQamutikVector />
              <Buoys />
              <RiverIce />
              <RiverIceMarkers />
              <MopraWellsites />
              <Mopra />
              <WellsiteRank />
              <WellsiteNdviControl />
              <WellsiteNdviLease />
              <WellsiteEviControl />
              <WellsiteEviLease />
              <PipelineGreen />
              <InfrastructurePipeline />
              <InfrastructurePipelineVector />
              <InfrastructurePipelineBuffer />
              <Infrastructure />
              <LeakDetection />
              <BriggsIceType />
              <BriggsIceDepth />
              <PolarviewApp />
              <FloodHazard />
              <FloodRiverClassification />
              <RiverFloodMonitoring />
              <ExploitsMarkers />
              <Sentinel1 />
              <Sentinel1SmartIce />
              <Sentinel2 />
              <Sentinel2Transparent />
              <Sentinel2LeakDetection />
              <Sentinel2SixMonth />
              <Sentinel1SixMonth />
              <Sentinel2Ndvi />
              <Sentinel2Raster />
              <CmemsSeaIce />
              <CmemsSnowThickness />
              <CmemsSurfaceTemperature />
              <Modis />
              <IceDrift />
              <IceDriftVelocity />
              <IceDeformation />
              <MopraVector />
              <Coastline />
              {Object.values(layers).map((Layer, index) => <Layer key={Layer.name+index} />)}
            </div>
          )}
      </Map>
    )
  }
}

const mapStateToProps = state => {
  return {
    idToken: state.login.idToken,
    authenticated: state.login.authenticated,
    center: state.map.center,
    maxBounds: state.map.maxBounds,
    pitch: state.map.pitch,
    style: state.map.style,
    uuidsHighlighted: state.object.uuidsHighlighted || [],
    zoom: state.map.zoom
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      boundsChanged: bounds => {
        dispatch(MapActions.updateBounds(bounds))
        dispatch(TimestampActions.boundsChanged(bounds))
      },
      clickEventUpdated: event => dispatch(ClickActions.clickEventUpdated(event)),
      toggleCenterChanged: center =>
        dispatch(MapActions.toggleCenterChanged(center)),
      toggleZoomChanged: zoom => dispatch(MapActions.toggleZoomChanged(zoom)),
      chartDataUpdated: featureData =>
        dispatch(ChartActions.chartDataUpdated(featureData)),
      objectToggled: object => dispatch(ObjectActions.objectToggled(object)),
      uuidsHighlighted: uuids =>
        dispatch(ObjectActions.uuidsHighlighted(uuids)),
      pointDataRequested: (lng, lat) =>
        dispatch(DataActions.pointDataRequested(lng, lat)),
      featuresSelected: features =>
        dispatch(ObjectActions.featuresSelected(features)),
      mouseChanged: event => dispatch(MouseActions.mouseChanged(event))
    }
  }
}

export default withErrorBoundary(connect(mapStateToProps, mapDispatchToProps)(MapboxMap))



// WEBPACK FOOTER //
// ./src/containers/MapboxMap.js